<div class="backModal enCalendar" *ngIf="disableButtonEnter()">
  <div class="margin d-flex justify-content-center">
    <div class="lds-ring esperando">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <p class="waiting-p">{{ 'IMPRIMIENDOTICKETS' | translate }}</p> <!-- Agregar el texto debajo del spinner -->
</div>
<ng-container *ngIf="albaran">
  <div class="Imprimir">
    <div class="tituloInt tituloVentas">
      {{ 'IMPRIMIR' | translate }} # {{ albaran.TPVId }}/ {{ albaran.NumVenta }}
      ({{ albaran.NumEntradas }} {{ 'ENTRADAS' | translate }})
    </div>

    <div class="ticket-info localiza-info">
      <div class="inputControl" [formGroup]="busquedaForm">
        <input
          category="FILTER"
          (focus)="focusValue($event)"
          class="localizador"
          formControlName="query"
          type="text"
          placeholder="{{ 'FILTRAR_NUM_TICKETS' | translate }}"
        />
        <img
          class="svg"
          src="assets/img/icon-search.svg"
          alt="icono busqueda"
        />
        <div class="close">
          <a title="{{ 'CERRAR' | translate }}"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
          >
        </div>
      </div>
      <div class="onoffswitch-wrapGeneral">
        <div class="onoffswitch-wrap">
          <div class="onoffswitch">
            <input
              #checkAllSwitch
              type="checkbox"
              checked="true"
              (change)="checkAllEntradas($event)"
              name="onoffswitch04"
              id="myonoffswitch04"
              class="onoffswitch-checkbox"
            />
            <label class="onoffswitch-label" for="myonoffswitch04"></label>
          </div>
          <label class="onoffswitch-label-text" for="myonoffswitch04"
          >{{ 'IMPRIMIR_TODAS' | translate }}</label
          >
        </div>
      </div>
    </div>

    <div class="ResumenResultado" *ngIf="albaran.TipoImpresion === '00'">
      <!-- <strong>Todas</strong> las
      <strong>{{ albaran.NumEntradas }}</strong> entradas listadas, -->
      <span *ngIf="selectedItems.length > 0"
      >{{ selectedItems.length }} {{ 'PRODUCTOS_SELECCIONADOS' | translateV2:'LOWER' }}</span
      >
    </div>

    <div class="ResumenResultado" *ngIf="albaran.TipoImpresion === '01'">
      <!-- <strong>Todas</strong> las
      <strong>{{ albaran.AlbaranTicketsDatosImpresion.length }}</strong>
      entradas conjuntas listadas, -->
      <span *ngIf="selectedItems.length > 0"
      >{{ selectedItems.length }} {{ 'PRODUCTOS_CONJUNTOS_SELECCIONADOS' | translateV2:'LOWER' }}</span>
    </div>

    <div class="Listadoresultado">
      <div class="Header">
        <div>{{ 'PRODUCTO' | translate }}</div>
        <div class="hidden"></div>
        <div>{{ 'TICKET' | translate }}</div>
      </div>

      <div class="checkboxStyledWrap">
        <ng-container *ngFor="let item of pagedItems | orderBy: 'OrdenCjta'; index as i">
          <div class="checkboxStyled">
            <div class="center">
              <label class="label" for="{{ item.TicketsRango }}">
                <input
                  class="label__checkbox"
                  type="checkbox"
                  [checked]="isChecked(item)"
                  [disabled]="item.Devuelta === '1'"
                  (change)="checkEntrada($event, item)"
                  id="{{ item.TicketsRango }}"
                  />
                <span *ngIf="item.Devuelta === '1'" class="label__check devuelta">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
                <span *ngIf="item.Devuelta !== '1'" class="label__check">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
              </label>
            </div>
            <label class="label__text" for="{{ item.TicketsGestion }}">
              <span class="sub-wrap">
                <span class="sub-tit">{{ item.NombreProducto }}</span>
              </span>
              <span class="number">{{ item.TicketsRango }}</span>
            </label>
            <div style="display: none;">{{ item.TicketsGestion }}</div>
          </div>
        </ng-container>
      </div>

      <ul class="pagination">
        <li>
          <a (click)="setPage(pager.currentPage - 1)" title="Previo">
            <img
              class="svg"
              src="assets/img/active-arrow.svg"
              alt="icono prev"
            />
          </a>
        </li>
        <li *ngFor="let page of pager.pages">
          <a
            (click)="setPage(page)"
            [ngClass]="{ active: pager.currentPage === page }"
          >{{ page }}</a
          >
        </li>
        <li>
          <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
            <img
              class="svg"
              src="assets/img/active-arrow.svg"
              alt="icono next"
            />
          </a>
        </li>
      </ul>
    </div>

    <div class="ButtonWrap">
      <button
        (click)="imprimir()"
        [disabled]="selectedItems.length === 0"
        class="bordeAzulButton imprimir"
        title="{{ 'IMPRIMIR' | translateV2:'UPPER' }}"
      >
        {{ 'IMPRIMIR' | translateV2:'UPPER' }}
        <span *ngIf="selectedItems.length > 0"
        >({{ selectedItems.length }})</span
        >
      </button>
    </div>
  </div>
</ng-container>
